import { Component } from '@angular/core';

import { CamDefaultPanelComponent, CamOverlayPanelComponent } from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [CamDefaultPanelComponent, CamOverlayPanelComponent, TestIdDirective],
    template: `
    <cam-overlay-panel camTestId="cam-overlay-panel" [panelConfig]="this.panelConfig">
      <ng-template #panelTrigger>
        <button>open panel</button>
      </ng-template>
      <ng-template #panelContent>
        <div>panel content</div>
      </ng-template>
    </cam-overlay-panel>
    <cam-default-panel camTestId="cam-default-panel" />
  `
})
export class UiOverlayCase {
  public panelConfig = { matchTriggerWidth: false };
}
